import { z } from "zod";
import { zodSortField } from "@/lib/utils";

const brandLetters = ["V", "A", "N", "S", "C"] as const;
const exclusivePrograms = ["O", "N"] as const;

const dominantNuanceCodes = [0, 1] as const;
const dominantColorCodes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9] as const;
const dominantNuanceCodesSet = new Set<number>(dominantNuanceCodes);
const dominantColorCodesSet = new Set<number>(dominantColorCodes);

export const getColorRulesRequestSchema = z.object({
  sort: zodSortField([
    "brandLetter",
    "year",
    "codeColor",
    "labelColor",
    "createdAt",
  ]).optional(),
});

export const addColorRuleSchema = z.object({
  brandLetter: z.enum(brandLetters),
  year: z
    .string()
    .trim()
    .regex(/^\d{4}$/, "Année doit contenir exactement 4 chiffres numériques"),
  exclusiveProgram: z.enum(exclusivePrograms),

  codeColor: z
    .string()
    .trim()
    .regex(
      /^[A-Za-z0-9]{4}$/,
      "code couleur doit faire 4 caractères alphanumériques",
    ),

  labelColor: z.string().trim().trim().min(1).max(200),

  dominantNuanceCode: z.coerce
    .number()
    .int()
    .refine((v) => dominantNuanceCodesSet.has(v), {
      message: "Code couleur dominante n°1 invalide (0=clair, 1=foncé)",
    }),
  dominantColorCode: z.coerce
    .number()
    .int()
    .refine((v) => dominantColorCodesSet.has(v), {
      message: "Code couleur dominante n°2 invalide (0=noir ... 9=blanc)",
    }),
});

export const editColorRuleSchema = addColorRuleSchema.extend({
  id: z.number().int().positive(),
  versionNote: z.string().max(500).optional(),
  isActive: z.boolean().default(true),
});

export const deleteColorRuleSchema = z.object({
  id: z.number().int().positive(),
});
